import moment from "moment";
import React from "react";
import { ITableColumn } from "src/components/FinalTable/FinalTable";
import { Checkbox } from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import { IApplicationComment } from "src/store/models/application.model";
import * as S from "../../../../constants/StringConstants";
import "./CommentsColumns.scss";

export const columns: ITableColumn<IApplicationComment>[] = [
  {
    key: "createdBy",
    title: S.APP_COMMENTS_COL_CREATED_BY,
    style: { textAlign: "left" },
  },
  {
    key: "description",
    title: S.APP_COMMENTS_COL_DESCRIPTION,
    style: { textAlign: "left" },
    render: item => item.description || <span className="wide-dash">-</span>,
  },
  {
    key: "createdDateTime",
    title: S.APP_COMMENTS_COL_CREATED,
    style: { textAlign: "left" },
    render: (item: IApplicationComment) => moment(item.createdDateTime).format("MM/DD/YYYY [at] h A"),
  },
  {
    key: "confidential",
    title: S.APP_COMMENTS_COL_CONFIDENTIAL,
    style: { textAlign: "left" },
    render: (item: IApplicationComment) => (
      <div className="confidential-checkbox">
        <Checkbox checked={item.confidential} />
      </div>
    ),
  },
];
